import { type RealtimeChannel, type SupabaseClient } from "@supabase/supabase-js";

import { type Database } from "@fitness-app/supabase";

/**
 * Detaches a realtime channel and hands back an empty slot.
 *
 * Every subscription keeps two fields around - the channel name and the channel itself.
 * Unsubscribing used to clear only the name, so the handle kept pointing at a channel
 * that was still joined; the next subscribe then skipped its removal because that guard
 * looked at the (already cleared) name too, and the socket collected one orphan per
 * subscribe/unsubscribe cycle. Assign the result to the channel field to keep both in
 * sync:
 *
 * ```ts
 * subscriptions.realtimeTraineeChannel = await closeRealtimeChannel(db, subscriptions.realtimeTraineeChannel);
 * subscriptions.traineeChannelName = null;
 * ```
 */
export const closeRealtimeChannel = async (
  db: SupabaseClient<Database>,
  channel: RealtimeChannel | null | undefined,
): Promise<null> => {
  if (channel) {
    await db.removeChannel(channel);
  }

  return null;
};
